import React, {useState} from "react"
import axios from "axios"
import {useFormik} from "formik"
import * as Yup from "yup"
import cx from "classnames"
import styles from "./styles.module.scss"
import TextInput from "../fields/text-input"
import SelectInput from "../fields/select"
import TextArea from "../fields/text-area"
import Calendar from "../../calendar"

const formSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  firstName: Yup.string().required("Required"),
  company: Yup.string().required("Required")
})

const Success = ({status, children}) => {
  if (!status) {
    return null
  }
  return <>{children}</>
}

interface Props {
  formId: string
  buttonText: string
  className?: string
}
const ContactForm: React.FC<Props> = ({formId, buttonText, className}) => {
  /* Server State Handling */
  const [serverState, setServerState] = useState({ok: false, msg: ""})
  const [isSuccessful, setSuccessful] = useState(true)

  const formik = useFormik({
    initialValues: {
      email: "",
      firstName: "",
      lastName: "",
      company: "",
      phone: "",
      subject: "",
      message: ""
    },
    validationSchema: formSchema,

    onSubmit: async (values) => {
      try {
        const response = await axios({
          method: "POST",
          url: `https://formspree.io/${formId}`,
          data: values
        })
        handleServerResponse(true, "Thank you for your submission.")
      } catch (error) {
        handleServerResponse(false, error.response.data.error)
      }
    }
  })
  // handleServerResponse
  const handleServerResponse = (ok, msg) => {
    setServerState({ok, msg})
  }

  return (
    <div className={cx(styles.FormContainer)}>
      <div className={cx(styles.Form, className)}>
        <form onSubmit={formik.handleSubmit}>
          {serverState && serverState.ok ? (
            <Success status={serverState.ok}>
              <h2>Thank you.</h2>
            </Success>
          ) : null}

          {serverState && !serverState.ok ? (
            <>
              <p className={!serverState.ok ? cx(styles.ErrorMsg) : ""}>
                {serverState.msg}
              </p>

              <div className={cx(styles.FormRow)}>
                <div className={cx(styles.FormCol)}>
                  <TextInput
                    value={formik.values.firstName}
                    touched={formik.touched.firstName}
                    error={formik.errors.firstName}
                    errorClass={cx(styles.ErrorMsg)}
                    handleBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    name="firstName"
                    label="First Name"
                  />
                </div>
                <div className={cx(styles.FormCol)}>
                  <TextInput
                    value={formik.values.lastName}
                    touched={formik.touched.lastName}
                    error={formik.errors.lastName}
                    errorClass={cx(styles.ErrorMsg)}
                    handleBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    name="lastName"
                    label="Last Name"
                  />
                </div>
              </div>
              <div className={cx(styles.FormRow)}>
                <div className={cx(styles.FormCol)}>
                  <TextInput
                    value={formik.values.company}
                    touched={formik.touched.company}
                    error={formik.errors.company}
                    errorClass={cx(styles.ErrorMsg)}
                    handleBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    name="company"
                    label="Company"
                  />
                </div>
              </div>
              <div className={cx(styles.FormRow)}>
                <div className={cx(styles.FormCol)}>
                  <TextInput
                    value={formik.values.email}
                    touched={formik.touched.email}
                    error={formik.errors.email}
                    errorClass={cx(styles.ErrorMsg)}
                    handleBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    name="email"
                    label="Email"
                    type="email"
                  />
                </div>
              </div>
              <div className={cx(styles.FormRow)}>
                <div className={cx(styles.FormCol)}>
                  <TextInput
                    value={formik.values.phone}
                    touched={formik.touched.phone}
                    error={formik.errors.phone}
                    errorClass={cx(styles.ErrorMsg)}
                    handleBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    name="phone"
                    label="Phone"
                    type="tel"
                  />
                </div>
              </div>
              <div className={cx(styles.FormRow)}>
                <div className={cx(styles.FormCol)}>
                  <SelectInput
                    value={formik.values.subject}
                    touched={formik.touched.subject}
                    error={formik.errors.subject}
                    errorClass={cx(styles.ErrorMsg)}
                    handleBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    options={["Inquiry", "Feedback", "Tips"]}
                    name="subject"
                    label="Subject"
                  />
                </div>
              </div>
              <div className={cx(styles.FormRow)}>
                <div className={cx(styles.FormCol)}>
                  <TextArea
                    value={formik.values.message}
                    touched={formik.touched.message}
                    error={formik.errors.message}
                    errorClass={cx(styles.ErrorMsg)}
                    handleBlur={formik.handleBlur}
                    handleChange={formik.handleChange}
                    name="message"
                    label="Message"
                  />
                </div>
              </div>
              <div className={cx(styles.FormRow)}>
                <div className={cx(styles.FormCol)}>
                  <button type="submit" disabled={formik.isSubmitting}>
                    {buttonText}
                  </button>
                </div>
              </div>
            </>
          ) : null}
        </form>
      </div>
			<div className={cx(styles.Calendar)}>
				<Calendar />
			</div>
    </div>
  )
}

export default ContactForm
